import apiClient from '../apiClient';
import { withCache } from '../../util';
import { CACHE_CONFIG } from '../../constants';
import {
  ReportFieldType,
  ReportIncludedField,
  ReportIncludedFieldFilterConcatOperator,
  ReportIncludedFieldFilterOperator,
} from '../../models';

export const fetchReportDefaultFields = async (
  standardReportId: number,
  clientId: number,
): Promise<ReportIncludedField[]> => {
  const defaultFields = await apiClient<ReportIncludedField[]>(
    `reporting/DefaultFields?standardReportId=${standardReportId}&clientId=${clientId}`,
  );
  return defaultFields.map((field) => ({
    ...field,
    reportMustHaveFieldFilters: (field.reportMustHaveFieldFilters || []).map(
      (filter) => ({
        ...filter,
        concatOperator:
          filter.concatOperator || ReportIncludedFieldFilterConcatOperator.and,
        operator: filter.operator || ReportIncludedFieldFilterOperator.equal,
        fieldValue1:
          field.reportPossibleField.fieldType === ReportFieldType.DropDown
            ? `${filter.id}`
            : filter.fieldValue1,
      }),
    ),
  }));
};

export const fetchReportDefaultFieldsWithCache = async (
  standardReportId: number,
  clientId: number,
): Promise<ReportIncludedField[]> =>
  withCache(async () => fetchReportDefaultFields(standardReportId, clientId), {
    ...CACHE_CONFIG.REPORT_DEFAULT_FIELDS,
    key: `${CACHE_CONFIG.REPORT_DEFAULT_FIELDS.key}-${standardReportId}-${clientId}`,
  });
